import moment from 'moment-timezone'

export default {
    methods: {
        isCourseOrCollectionExpired (entity) {
            if (!entity) {
                return null
            }

            let expireDate = entity.expirationDate
            let today = moment().tz(this.getTimeZone()).startOf('day')
            let expiredDiff = expireDate !== null ? today.diff(expireDate, 'days') : null

            return (expiredDiff > 0 && expiredDiff !== null) || ['draft', 'expired'].includes(entity.status) || entity.isExpired
        }
    }
}
